export const customersTabForPath = (pathname: string) =>
	pathname.startsWith("/people") ? "people" : "companies"
